import { SignatureFieldModel } from '@types'

import { SignaturePad } from '@components/SignaturePad'

import { Container, HiddenInput } from './SubmitterFieldSignature.styled'

type SubmitterFieldSignatureProps = {
  field: SignatureFieldModel
  onChange: (updates: Partial<SignatureFieldModel>) => void
  disabled?: boolean
}

export const SubmitterFieldSignature: React.FC<SubmitterFieldSignatureProps> = ({
  field,
  onChange,
  disabled = false,
}: SubmitterFieldSignatureProps) => {
  return (
    <Container>
      <SignaturePad
        label={field.label}
        initialDataUrl={field.value}
        onSave={(data) => {
          onChange({ value: data })
        }}
        disabled={disabled}
      />
      <HiddenInput type="text" value={field.value || ''} required={field.required} onChange={() => {}} />
    </Container>
  )
}
